module.exports = __webpack_public_path__ + "static/media/03-video-hotspot.9d6c643e.png";